import React, { useState, useEffect, useContext } from "react"
import { ButtonGroup, Col, Form, Row } from "react-bootstrap"
import toast from "react-hot-toast"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import Delete from "../../../Components/Modals/DeleteModal"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import {
  createBir2037ExpensePayments,
  deleteBankSe,
  deleteCashSe,
  deleteCheckSe,
  deleteOthersSe,
  deleteSuppliesAdvancePayment,
} from "../../../Helpers/apiCalls/Expenses/sePaymentsListApi"
import { getAllSePayments } from "../../../Helpers/apiCalls/Expenses/sePaymentsListApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import {
  numberFormat,
  toastStyle,
  getTodayDate,
  isAdmin,
  selectDropdownStyle,
  refreshPage,
} from "../../../Helpers/Utils/Common"

import "../PurchaseOrders/PurchaseOrders.css"
import "./PaySuppliers.css"
import DatePicker from "react-datepicker"
import Moment from "moment"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import GenerateBirModal from "../../Purchases/PurchaseOrders/Components/GenerateBirModal"
import BirForm from "../../Purchases/Pay Suppliers/Components/BirForm"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function PaySuppliers() {
  let navigate = useNavigate()
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)
  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const [paymentDeets, setPaymentDeets] = useState({ id: "", payment: "" })
  const [selectedRow, setSelectedRow] = useState({})
  const [filterConfig, setFilterConfig] = useState({
    page: 1,
    start_date: dateFilter.date_from || "",
    end_date: dateFilter.date_to || "",
  })
  const [inactive, setInactive] = useState(true)
  const [filteredData, setFilteredData] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement
  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)
  const [summary, setSummary] = useState([])
  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  async function handleDeleteSP() {
    setIsClicked(true)
    if (selectedRow.doc_no === "Advance Payment") {
      const response = await deleteSuppliesAdvancePayment(paymentDeets.id)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => refreshPage(), 1000)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setTimeout(() => refreshPage(), 1000)
      }
    } else {
      if (paymentDeets.payment.includes("cash")) {
        const response = await deleteCashSe(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setShowDeleteModal(false)
          fetchAllSePayments()
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
        }
      } else if (paymentDeets.payment.includes("check")) {
        const response = await deleteCheckSe(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setShowDeleteModal(false)
          fetchAllSePayments()
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
        }
      } else if (paymentDeets.payment.includes("bank")) {
        const response = await deleteBankSe(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setShowDeleteModal(false)
          fetchAllSePayments()
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
        }
      } else if (
        paymentDeets.payment.includes("others") ||
        paymentDeets.payment.includes("other")
      ) {
        const response = await deleteOthersSe(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setShowDeleteModal(false)
          fetchAllSePayments()
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
        }
      }
    }
    setIsClicked(false)
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    if (name === "supplier_id") {
      var id = value.split("|")[0]
      var type = value.split("|")[1]
      var by = value.split("|")[2]
      if (by === "supplier") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: id,
            supplier_id: id,
            vendor_id: "",
            type: type,
          }
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: "",
            supplier_id: "",
            vendor_id: id,
            type: type,
          }
        })
      }
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          [name]: value,
        }
      })
    }
  }

  // function handleSelectChange(e) {

  //     if (e.name === "supplier_id") {
  //         setSupplierValue({ name: e.name, label: e.label, value: e.value });
  //         // fetchReceives(e.value);
  //     } else if (e.name === "bank_id")
  //         setBankValue({ name: e.name, label: e.label, value: e.value });
  // }

  const [suppliers, setSuppliers] = useState([])

  const [supplierList, setSupplierList] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState("")

  // useEffect(()=>{
  //     //
  //     setSupplierList(suppliers.map((supplier)=>{
  //         return {label: supplier.trade_name, value:supplier.id + "|" + supplier.type};
  //     }))
  //     setSupplierList((branches)=>{
  //         var newBranches = [...branches];
  //         newBranches.push({label: "All Suppliers", value:""})
  //         return newBranches.reverse();
  //     });

  //     //
  // },[suppliers])

  function handleSupplierChange(e) {
    setSelectedSupplier(e.name)
    const toFilter = { target: { name: "supplier_id", value: e.value } }
    handleFilterChange(toFilter)
  }

  // async function handleGenerateBir2037() {
  //   setIsClicked(true)
  //   console.log("generate")

  //   // yet to be changed
  //   var response = await createBir2037ExpensePayments(
  //     selectedRow.id,
  //     selectedRow.payment_mode
  //   )

  //   if (response.data) {
  //     console.log(response.data)
  //     //extract data from response and then feed to excel
  //     toast.success("BIR 2037 generated successfully", {
  //       style: toastStyle(),
  //     })
  //     // setTimeout(() => refreshPage(), 1000)
  //     // handleExcelGeneration(response)
  //     //after a successfull generation close modal
  //   } else {
  //     response.error?.response?.data?.messages.map((data) => {
  //       return toast.error(data)
  //     })
  //     // setTimeout(() => refreshPage(), 1000);
  //   }
  //   setIsClicked(false)
  // }

  async function handleGenerateBir2037() {
    toast.loading("Printing Form 2307", { style: toastStyle() })
    // handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  async function fetchSuppliers() {
    const suppliersResponse = await getAllSuppliers()
    if (suppliersResponse.data) {
      suppliersResponse.data.data.map((supplier) => {
        var info = supplier
        info.type = "supplier"
        setSuppliers((prev) => [...prev, info])
      })
    }
  }

  async function fetchAllSePayments() {
    setShowLoader(true)
    setFilteredData([])
    setTotalItems(0)
    const response = await getAllSePayments(filterConfig)
    if (response.data) {
      setSummary(response.data.total_amount)
      var allPayments = response.data.data.map((data) => {
        var payment = data
        payment.amount = numberFormat(payment.amount)
        payment.bank_name =
          payment.payment_mode === "bank"
            ? `${payment.bank_from_name || "N/A"} to ${
                payment.bank_to_name || "N/A"
              }`
            : payment.bank_from_name || "N/A"
        payment.date = Moment(payment.date).format("MMM DD, YYYY") || "N/A"
        payment.doc_no = payment.doc_no || "N/A"
        payment.issued_date =
          Moment(payment.date).format("MMM DD, YYYY") || "N/A"
        payment.payee = payment.payee || "N/A"
        payment.payment_mode =
          payment.payment_mode === "check"
            ? payment.payment_mode + " - " + payment.check_no
            : payment.payment_mode === "bank"
            ? payment.payment_mode + " - " + payment.reference_no
            : payment.payment_mode
        payment.supplier = payment.supplier || payment.vendor || "N/A"
        return payment
      })

      setFilteredData(allPayments)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit-ps") {
      navigate("/se/paysuppliers/edit/" + row.id + "/" + row.payment_mode)
    } else if (e.target.value === "delete-ps") {
      handleShowDeleteModal()
      setSelectedRow(row)
      setPaymentDeets({ id: row.id, payment: row.payment_mode })
    } else if (e.target.value === "view-ps") {
      // window.open(
      //     "/se/paysuppliers/view/" + row.id + "/" + row.payment_mode,"_blank"
      // );
      window.open(
        "/se/paysuppliers/view/" +
          row.id +
          "/" +
          row.payment_mode.split(" ")[0],
        "_blank"
      )
    } else if (e.target.value === "approve-ps") {
      navigate("/se/paysuppliers/approve/" + row.id)
    } else if (e.target.value === "generate-bir") {
      handleShowGenerateBirModal()
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        role={row.payment_mode}
        id={row.id}
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        {/* {type === "pending" && isAdmin ? (
                    <option value="edit-ps" className="color-options">
                        Edit
                    </option>
                ) : null} */}
        <option value="view-ps" className="color-options">
          View
        </option>
        {type === "approved" ? (
          <option value="reprint-ps" className="color-options">
            Reprint
          </option>
        ) : null}
        {isAdmin && (
          <option value="delete-ps" className="color-red">
            Void Payment
          </option>
        )}
        {isAdmin && (
          <option value="generate-bir" className="color-red">
            Generate BIR 2307
          </option>
        )}
      </Form.Select>
    )
  }

  function ViewPayment(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => handleViewPayment(row.id, row.payment_mode)}
      >
        View
      </button>
    )
  }

  function handleViewPayment(id, payment_mode) {
    window.open(
      "/se/paysuppliers/view/" + id + "/" + payment_mode.split(" ")[0],
      "_blank"
    )
  }

  function handleAddChange(e) {
    navigate("/se/paysuppliers/add/" + e.target.value)
  }

  function InvoiceBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.invoice_numbers?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button p-1"
                onClick={() => handleViewContract(row)}
              >
                {`INV.${row}`}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }
  function handleViewContract(id) {
    window.open("/se/purchaseinvoices/print/" + id, "_blank")
  }

  // useEffect(() => {
  //     fetchSuppliers();
  // }, []);

  useEffect(() => {
    fetchAllSePayments()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES PAYMENTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}

        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EXPENSE PAYMENTS
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeholder="Search..."
              // onChange={(e) => handleFilterChange(e)}
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <Form.Select
                className="me-3 add-type"
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" hidden selected>
                  Add
                </option>
                <option value="bank">Bank to Bank</option>
                <option value="cash">Cash</option>
                <option value="check">Check</option>
                <option value="others">Others</option>
              </Form.Select>
            </div>
          </Col>
        </Row>

        <div className="tab-content __table-container">
          {/* filters */}
          <div className="mb-3" />
          <span className=" mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row my-1">
            {/* <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Supplier"
                                styles={selectDropdownStyle}
                                value={selectedSupplier}
                                options={supplierList}
                                onChange={handleSupplierChange}
                            />
                        </Col> */}
            <Col xs={6} lg={2} className="mb-2 mb-lg-0">
              <Form.Select
                name="payment_mode"
                className="date-filter force-width w-full"
                onChange={(e) => handleFilterChange(e)}
                value={filterConfig.payment_mode}
              >
                <option value="" hidden selected>
                  Payment Mode
                </option>
                <option value="">All</option>
                <option value="bank">Bank</option>
                <option value="cash">Cash</option>
                <option value="check">Check</option>
                <option value="other">Other</option>
              </Form.Select>
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                name="start_date"
                className="date-filter me-4 form-control"
                placeholderText="Select Date From"
                selected={filterConfig.start_date}
                onChange={(date) => {
                  setDateFrom(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, start_date: date }
                  })
                }}
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                name="end_date"
                className="date-filter ps-label-content me-5 form-control"
                placeholderText="Select Date To"
                selected={filterConfig.end_date}
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, end_date: date }
                  })
                }}
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className=" PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 mt-2 ps-label">
              Total Amount: {summary === 0 ? "0.00" : numberFormat(summary)}
            </span>
          </div>
          <div className="mb-2" />
          <div>
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE ISSUED",
                "SUPPLIER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "INVOICES APPLIED",
                "DOC NO.",
                "BANK NAME",
                "DATE ADDED",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "issued_date",
                "supplier",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "doc_no",
                "bank_name",
                "date",
              ]}
              tableData={filteredData}
              ActionBtn={(row) => ActionBtn(row, "pending")}
              ViewBtn={(row) => ViewPayment(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-2" />
        </div>
      </div>

      <Delete
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        text="payment"
        onDelete={handleDeleteSP}
        isClicked={isClicked}
      />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2307 for this purchase invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />

      <Footer />
      <BirForm
        id={selectedRow.id}
        type="supplies-payment"
        mode={selectedRow.payment_mode}
      />
    </div>
  )
}
